const setEventListeners = () => {
  const buttons = [...document.querySelectorAll('.js-remove-from-cart')]

  buttons.forEach((button) => {
    button.addEventListener('click', ({ target }) => {
      const { ajaxurl } = window.path   //eslint-disable-line
      const { productId, productSku, variationId } = target.dataset

      const data = new FormData()
      data.append('action', 'pf_cart_remove')
      data.append('product_id', productId)
      data.append('product_sku', productSku)
      data.append('variation_id', variationId)
      data.append('quantity', '1')

      button.style.opacity = 0.5

      fetch(ajaxurl, {
        method: 'POST',
        body: data,
      })
        .then((response) => response.json())
        .then((payload) => {
          if (payload) {
            button.style.opacity = 1
            window.emitter.emit('update-cart', payload)
          }
        })
        .catch((error) => {
            console.error('Error:', error) //eslint-disable-line
        })
    })
  })
}

const initRemoveFromCart = () => {
  setEventListeners()
  window.emitter.on('cart-updated', initRemoveFromCart)
}
export default initRemoveFromCart
